import { render, staticRenderFns } from "./Leyend.vue?vue&type=template&id=baae1454"
import script from "./Leyend.vue?vue&type=script&lang=js"
export * from "./Leyend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports